import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseUI } from '../../base.ui';
import { FullClient, RelativeRelationship } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { PublicDutiesOption } from '../../../../core';

@Component({
    selector: 'thr-full-data-three-natural-person',
    templateUrl: './full-data-three-natural-person.component.html',
    styleUrls: ['./full-data-three-natural-person.component.scss'],
})
export class FullDataThreeNaturalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public PublicDutiesOption: typeof PublicDutiesOption = PublicDutiesOption;

    public form: NgForm;
    public isFormValid = false;

    public adding = false;
    public editing = false;
    public currentRelationship: RelativeRelationship;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Input()
    isDisabledSubmit = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        if (this.client.publicDuties.isImportantRelative && this.client.publicDuties.relativeRelationship.length === 0) {
            this.onAdd();
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onResize() {
        this.parentEvents.resize();
    }

    onImportantRelativeChange() {
        if (this.client.publicDuties.isImportantRelative && this.client.publicDuties.relativeRelationship.length === 0) {
            this.onAdd();
        } else if (!this.client.publicDuties.isImportantRelative) {
            this.onCancel();
        }

        this.parentEvents.resize();
    }

    onAdd() {
        if (!this.client.publicDuties.isFull()) {
            this.currentRelationship = new RelativeRelationship();
            this.adding = true;
            this.editing = false;
        }
    }

    onSave() {
        if (this.adding && !this.client.publicDuties.isFull()) {
            this.client.publicDuties.addRelationship(this.currentRelationship);
        } else if (this.editing) {
            this.client.publicDuties.updateRelationship(this.currentRelationship);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentRelationship = undefined;

        this.parentEvents.resize();
    }

    onEdit(relationship: RelativeRelationship) {
        this.currentRelationship = cloneDeep(relationship);
        this.editing = true;
        this.adding = false;
    }

    onRemove(relationship: RelativeRelationship) {
        this.client.publicDuties.removeRelationship(relationship);

        if (this.currentRelationship && String(this.currentRelationship.id) === String(relationship.id)) {
            this.onCancel();
        }

        if (!this.adding && this.client.publicDuties.relativeRelationship.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }
}
